import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageService } from './shared/services/language.service';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest } from 'rxjs';
import { AuthenticationService } from './shared/services/authentication.service';
import { skipWhile, take } from 'rxjs/operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(private languageService: LanguageService,
              private auth0Service: AuthService,
              private authService: AuthenticationService
              ) {
  }

  ngOnInit(): void {

    this.languageService.initTranslation();

    this.auth0Service.isAuthenticated$.subscribe(isAuth => {
      if (isAuth) {
        combineLatest([this.auth0Service.idTokenClaims$, this.auth0Service.getAccessTokenSilently()]).pipe(
          skipWhile(([idToken, accessToken]) => !idToken || !accessToken)
        ).pipe(take(1)).subscribe(([idToken, accessToken]) => {
          this.authService.initAuthenticationParams(idToken, accessToken);
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.authService.disconnect();
  }
}
